<template>
  <div class="tab-sticky" :class={show:show}>
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'tab-sticky',
  props: {
    active: '',
    show: false
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";

.tab-sticky {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: -222px;
  z-index: 9999;
  background-color: $white;
  transition: bottom 300ms ease;
  &.show {
    bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tabs/TabSticky.vue